var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D2D2",
    d: "M24 4.668V2.227c0-1.147-.97-2.08-2.16-2.08H2.16C.97.147 0 1.08 0 2.227v2.441h24z",
    transform: "translate(-665 -757) translate(665 757) translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5EA3D7",
    d: "M0 6.449v7.333c0 1.147.97 2.071 2.16 2.071h19.68c1.19 0 2.16-.924 2.16-2.07V6.448H0zm19.015 5.68h-3.101c-.508 0-.923-.4-.923-.889s.415-.889.923-.889h3.101c.508 0 .923.4.923.889s-.415.889-.923.889z",
    transform: "translate(-665 -757) translate(665 757) translate(0 4)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.63fa010321f2e3a6e8aca1d585413c86.svg";
export { ForwardRef as ReactComponent };